<!-- Button Container -->
<div class="button-container">
  <!-- Tools Button — only in general mode. Offers the real surfaces (Code / Writing). -->
  <button 
    *ngIf="!showInlineTemperature"
    #toolsButton
    class="tools-button"
    [class.active]="isPopupVisible"
    (click)="togglePopup($event)">
    <img src="assets/custom-icons/tools.svg" alt="Tools" class="tools-icon" />
    <span class="tools-label">Tools</span>
  </button>

  <!-- Temperature control — ALWAYS available (it's a creativity dial, not a mode).
       Just an icon; click opens a slider popover, click outside closes it. -->
  <div class="temperature-control">
    <button
      type="button"
      class="temperature-icon-btn"
      [class.active]="isTemperatureContainerVisible"
      (click)="toggleInlineTemperature($event)"
      title="Temperature">
      <img src="assets/custom-icons/temperature.svg" alt="Temperature" class="inline-temp-icon" />
    </button>

    <div class="temperature-popover" *ngIf="isTemperatureContainerVisible">
      <label class="slider-label">Temperature</label>
      <div class="underline"></div>
      <input
        type="range"
        min="0" max="1" step="0.01"
        [ngModel]="temperature"
        (ngModelChange)="onTemperatureChange($event)"
        [style.background]="'linear-gradient(to right, #005797 ' + (temperature * 100) + '%, #e5e5e5 ' + (temperature * 100) + '%)'"
      />
      <div class="slider-value">{{ temperature.toFixed(2) }}</div>
    </div>
  </div>
</div>

<!-- Mode Selection Popup — only the two real surfaces. Selection is tentative
     until the user clicks Apply or clicks outside, so they can switch/back out. -->
<div class="mode-popup" *ngIf="isPopupVisible" #popup [class.top]="popupPosition === 'top'" [class.bottom]="popupPosition === 'bottom'">
  <div class="popup-title">Tools</div>
  <button 
    class="mode-option"
    [class.selected]="pendingMode === 'code'"
    (click)="selectMode('code')">
    <img src="assets/custom-icons/code.svg" alt="Code Mode" class="mode-icon" />
    <span class="mode-label">Code</span>
    <img *ngIf="pendingMode === 'code'" src="assets/custom-icons/checkmark.svg" alt="Selected" class="mode-check" />
  </button>
  <button 
    class="mode-option"
    [class.selected]="pendingMode === 'writing'"
    (click)="selectMode('writing')">
    <img src="assets/custom-icons/writing.svg" alt="Writing Mode" class="mode-icon" />
    <span class="mode-label">Writing</span>
    <img *ngIf="pendingMode === 'writing'" src="assets/custom-icons/checkmark.svg" alt="Selected" class="mode-check" />
  </button>
  <button
    class="mode-apply"
    (click)="applyPendingMode($event)">
    {{ pendingMode ? 'Apply' : 'None' }}
  </button>
</div>
